module.exports = __webpack_public_path__ + "static/media/btn_devices_1075_725.aa5e45d7.png";